import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { useSettingsStore } from "@/stores/SettingsStore";
import { storeToRefs } from "pinia";
import { FileServiceSymbol } from "@/InjectionSymbols";
import { inject, onMounted, reactive, ref } from "vue";
import { useMessageStore } from "@/stores/MessageStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceSettingsView',
    setup(__props) {
        const messageStore = useMessageStore();
        const settingsStore = useSettingsStore();
        const { settings, loadedPrivate } = storeToRefs(settingsStore);
        const settingsDirtyState = reactive(new Set());
        const fileService = inject(FileServiceSymbol);
        const editInfoText = ref(false);
        let saveInFlight = ref(false);
        const logoUrl = ref("");
        onMounted(() => {
            if (!loadedPrivate.value) {
                useSettingsStore().loadPrivateSettings().then(() => loadLogo());
            }
            else {
                loadLogo();
            }
        });
        async function loadLogo() {
            const image = settings.value.get('company_logo').value;
            if (image) {
                const imageSrc = await fileService.getImageSrc(image);
                if (imageSrc && imageSrc.length > 0) {
                    logoUrl.value = imageSrc;
                }
            }
        }
        function onSettingChanged(newValue, key) {
            settings.value.get(key).value = newValue;
            settingsDirtyState.add(key);
        }
        function save() {
            saveInFlight.value = true;
            const promises = [];
            settingsDirtyState.forEach(dirtyKey => {
                promises.push(settingsStore.upload(dirtyKey));
            });
            Promise.all(promises).then(() => {
                messageStore.addMessage("Erfolgreich gespeichert");
            }).catch(() => {
                messageStore.addError("Fehler beim Speichern");
            }).finally(() => {
                saveInFlight.value = false;
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    (_unref(loadedPrivate))
                        ? (_openBlock(), _createBlock(_component_v_container, {
                            key: 0,
                            fluid: true,
                            class: "d-flex flex-wrap ma-0 pa-0"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_container, { class: "text-h4 text-start v-col-12" }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode(" Rechnung Einstellungen ")
                                    ])),
                                    _: 1
                                }),
                                _createVNode(_component_v_container, { class: "text-start ml-0" }, {
                                    default: _withCtx(() => [
                                        _cache[5] || (_cache[5] = _createTextVNode(" Hier wird ein Beispiel angezeigt, wie eine generierte Rechnung aussehen könnte. Bereiche, die mit dem ")),
                                        _createVNode(_component_v_icon, {
                                            class: "",
                                            icon: "mdi-pencil-box-outline",
                                            size: "x-large",
                                            color: "info"
                                        }),
                                        _cache[6] || (_cache[6] = _createTextVNode(" Icon markiert sind, können von dir bearbeitet werden. Klicke dazu auf das Icon. "))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card, {
                                    style: { "width": "21cm", "height": "29.7cm" },
                                    class: "ma-4 invoice-preview",
                                    elevation: "4"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_container, { style: { "padding": "1cm" } }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_container, { class: "pa-0 pb-8 d-flex justify-space-between" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "w-auto ml-0 pa-0" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_img, {
                                                                    height: "200px",
                                                                    src: logoUrl.value
                                                                }, null, 8, ["src"])
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_container, { class: "w-auto mr-0 text-start pa-0" }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("h4", null, _toDisplayString(_unref(settings).get('company_name').value), 1),
                                                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                                                _createElementVNode("div", null, _toDisplayString(_unref(settings).get('company_ceo').value), 1),
                                                                _createElementVNode("div", null, _toDisplayString(_unref(settings).get('company_street').value), 1),
                                                                _createElementVNode("div", null, _toDisplayString(_unref(settings).get('company_city').value), 1),
                                                                _createElementVNode("div", null, _toDisplayString(_unref(settings).get('company_phone').value), 1),
                                                                _createElementVNode("div", null, _toDisplayString(_unref(settings).get('company_email').value), 1),
                                                                _createElementVNode("div", null, _toDisplayString(_unref(settings).get('company_tax_id').value), 1)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_container, { class: "pa-0 pb-6 d-flex justify-space-between" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "pa-0 w-auto ml-0 text-start" }, {
                                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                _createElementVNode("div", null, "Musterfirma", -1),
                                                                _createElementVNode("div", null, "Max Mustermann", -1),
                                                                _createElementVNode("div", null, "Musterstrasse 1", -1),
                                                                _createElementVNode("div", null, "12345 Musterstadt", -1),
                                                                _createElementVNode("div", null, "+49 123 45 67", -1),
                                                                _createElementVNode("div", null, "max@mustermann.de", -1)
                                                            ])),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_container, { class: "pa-0 w-auto mr-0 text-start" }, {
                                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                _createElementVNode("div", null, "Rechnungsnummer: L2023.0493_R3", -1),
                                                                _createElementVNode("div", null, "Rechnungsdatum: 01.12.2023", -1),
                                                                _createElementVNode("div", null, "Bestelldatum: 15.11.2023", -1),
                                                                _createElementVNode("div", null, "Zahlungsart: Überweisung", -1)
                                                            ])),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_container, {
                                                    style: { "font-size": "1.5em" },
                                                    class: "pa-0 text-start"
                                                }, {
                                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                        _createTextVNode(" Mietvertrag und Rechnung ")
                                                    ])),
                                                    _: 1
                                                }),
                                                (editInfoText.value)
                                                    ? (_openBlock(), _createBlock(_component_v_textarea, {
                                                        key: 0,
                                                        rows: "4",
                                                        "no-resize": "",
                                                        label: "Hinweistext",
                                                        modelValue: _unref(settings).get('invoice_info_text').value,
                                                        "onUpdate:modelValue": [
                                                            _cache[0] || (_cache[0] = ($event) => ((_unref(settings).get('invoice_info_text').value) = $event)),
                                                            _cache[1] || (_cache[1] = ($event) => (onSettingChanged($event, 'invoice_info_text')))
                                                        ],
                                                        onBlur: _cache[2] || (_cache[2] = ($event) => (editInfoText.value = false))
                                                    }, null, 8, ["modelValue"]))
                                                    : _createCommentVNode("", true),
                                                _createVNode(_component_v_container, {
                                                    style: { "font-size": "0.75em" },
                                                    class: "pa-0 text-start"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(settings).get('invoice_info_text').value) + " ", 1),
                                                        _createVNode(_component_v_icon, {
                                                            class: "pl-2 cursor-pointer",
                                                            icon: "mdi-pencil-box-outline",
                                                            size: "x-large",
                                                            color: "info",
                                                            onClick: _cache[3] || (_cache[3] = ($event) => (editInfoText.value = !editInfoText.value))
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "table" }, [
                                                    _createElementVNode("div", { class: "row table-head" }, [
                                                        _createElementVNode("div", { class: "col-1" }, [
                                                            _createElementVNode("b", null, "Gebuchte Leistungen")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-2" }),
                                                        _createElementVNode("div", { class: "col-3" }, [
                                                            _createElementVNode("b", null, "Preis")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-4" }, [
                                                            _createElementVNode("b", null, "Anzahl")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-5" }, [
                                                            _createElementVNode("b", null, "Zwischensumme")
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", { class: "row border-top" }, [
                                                        _createElementVNode("div", { class: "col-1" }, [
                                                            _createElementVNode("div", null, "1 - Tagestour Wetzlar - Solms"),
                                                            _createElementVNode("div", null, "10.07.2023 - 10.07.2023")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-2" }, [
                                                            _createElementVNode("div", null, "Erwachsene (ab 14 J.)"),
                                                            _createElementVNode("div", null, "Kinder"),
                                                            _createElementVNode("div", null, "Menge")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-3" }, [
                                                            _createElementVNode("div", null, "0,00 €"),
                                                            _createElementVNode("div", null, "0,00 €"),
                                                            _createElementVNode("div", null, "0,00 €")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-4" }, [
                                                            _createElementVNode("div", null, "0"),
                                                            _createElementVNode("div", null, "0"),
                                                            _createElementVNode("div", null, "0")
                                                        ]),
                                                        _createElementVNode("div", { class: "col-5" }, [
                                                            _createElementVNode("div", null, "0,00 €"),
                                                            _createElementVNode("div", null, "0,00 €"),
                                                            _createElementVNode("div", null, "0,00 €"),
                                                            _createElementVNode("div", null, "0,00 €")
                                                        ])
                                                    ])
                                                ], -1)),
                                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "table" }, [
                                                    _createElementVNode("div", { class: "row border-top-thick" }, [
                                                        _createElementVNode("div", {
                                                            class: "col-1",
                                                            style: { "font-weight": "bold" }
                                                        }, "Zwischensumme"),
                                                        _createElementVNode("div", { class: "col-2" }),
                                                        _createElementVNode("div", { class: "col-3" }),
                                                        _createElementVNode("div", { class: "col-4" }),
                                                        _createElementVNode("div", {
                                                            class: "col-5",
                                                            style: { "font-weight": "bold" }
                                                        }, "0,00 € ")
                                                    ]),
                                                    _createElementVNode("div", { class: "row" }, [
                                                        _createElementVNode("div", {
                                                            class: "col-1",
                                                            style: { "font-weight": "bold" }
                                                        }, "Rabatt"),
                                                        _createElementVNode("div", { class: "col-2" }),
                                                        _createElementVNode("div", { class: "col-3" }),
                                                        _createElementVNode("div", { class: "col-4" }),
                                                        _createElementVNode("div", {
                                                            class: "col-5",
                                                            style: { "font-weight": "bold" }
                                                        }, "0,00 €")
                                                    ])
                                                ], -1)),
                                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "table" }, [
                                                    _createElementVNode("div", { class: "row" }, [
                                                        _createElementVNode("div", {
                                                            class: "col-1",
                                                            style: { "width": "3%" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-2",
                                                            style: { "width": "56%", "font-size": "0.75em" }
                                                        }, "1 Kind pro 2 Erw. kostenlos "),
                                                        _createElementVNode("div", {
                                                            class: "col-3",
                                                            style: { "width": "0" }
                                                        }),
                                                        _createElementVNode("div", { class: "col-4" }),
                                                        _createElementVNode("div", {
                                                            class: "col-5",
                                                            style: { "font-size": "0.75em" }
                                                        }, "0,00 € ")
                                                    ]),
                                                    _createElementVNode("div", { class: "row border-top-thick" }, [
                                                        _createElementVNode("div", {
                                                            class: "col-1",
                                                            style: { "width": "3%" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-2",
                                                            style: { "width": "56%" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-3",
                                                            style: { "width": "0" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-4",
                                                            style: { "font-size": "1.25em", "font-weight": "bold" }
                                                        }, "Total"),
                                                        _createElementVNode("div", {
                                                            class: "col-5",
                                                            style: { "font-size": "1.25em", "font-weight": "bold" }
                                                        }, "0,00 € ")
                                                    ]),
                                                    _createElementVNode("div", { class: "row" }, [
                                                        _createElementVNode("div", {
                                                            class: "col-1",
                                                            style: { "width": "3%" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-2",
                                                            style: { "width": "56%" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-3",
                                                            style: { "width": "0" }
                                                        }),
                                                        _createElementVNode("div", {
                                                            class: "col-4",
                                                            style: { "width": "23%" }
                                                        }, "inkl. 19% MwSt."),
                                                        _createElementVNode("div", { class: "col-5" }, "0,00 €")
                                                    ])
                                                ], -1)),
                                                _createVNode(_component_v_container, { class: "px-0 pb-4 font-weight-bold text-start" }, {
                                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                        _createTextVNode(" Bitte überweisen Sie den Rechnungsbetrag innerhalb von 14 Tagen auf unser Konto bei ING-DiBa, IBAN: DE12 3456 7890 1234 5678 90, BIC: INGDDEFFXXX. ")
                                                    ])),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_container, { class: "pa-0 text-start" }, {
                                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                        _createTextVNode(" Wir bedanken uns für Ihren Auftrag und freuen uns auf Ihren Besuch! ")
                                                    ])),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_container, { class: "d-flex pt-0 ml-0" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_btn, { onClick: save }, {
                                            default: _withCtx(() => [
                                                (!_unref(saveInFlight))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Speichern"))
                                                    : _createCommentVNode("", true),
                                                (_unref(saveInFlight))
                                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                        key: 1,
                                                        indeterminate: true
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
